import { createContext, useContext } from 'react'

export type NuxEvent =
  | { type: 'nodeSelected'; nodeId: string; nodeType?: string }
  | { type: 'nodeReady'; nodeId: string; nodeType?: string }
  | { type: 'panelOpened'; panelId?: string; nodeId?: string; nodeType?: string }
  | { type: 'editorOpened'; editorId?: string }
  | { type: 'exportCompleted'; editorId?: string }
  | { type: 'voiceAdded'; nodeId?: string; nodeType?: string }
  | { type: 'controlActivated'; controlId: string; anchorId?: string; nodeId?: string; nodeType?: string; panelId?: string }

export interface NuxTooltipEvents {
  emitNuxEvent: (event: NuxEvent) => void
}

export const NuxTooltipEventsContext = createContext<NuxTooltipEvents>({
  emitNuxEvent: () => {},
})

export function useNuxTooltipEvents(): NuxTooltipEvents {
  return useContext(NuxTooltipEventsContext)
}
